// extracted by mini-css-extract-plugin
export default {"icon":"Os_icon__mu7Yc"};